import {createFileRoute} from '@tanstack/react-router';

import {monitorTabActiveTabQueryParam, replaceRoute, Route as Routes} from '~utils/routeUtil';

import {DashboardTab} from '~components/dashboard/Dashboard';

export const Route = createFileRoute('/heatmap/')({
  component: HeatmapPage,
});

function HeatmapPage(): JSX.Element | null {
  replaceRoute(Routes.monitor, {query: {[monitorTabActiveTabQueryParam]: DashboardTab.Heatmap}});
  return null;
}
